/** @format */

import { Address } from './address/address.interface';
import { AddressV2 } from './address/address-v2.interface';
import { Injectable } from '@angular/core';
import { Phone } from './phone.interface';

@Injectable()
export class PersonalInformation {
  addresses: Address[];
  phoneNumbers: Phone[];
  email = '';
  loyaltyNumber = '';
  userId = '';
  lastName = '';
  firstName = '';
  isGold = false;
  currentYearSales = 0;
  tierExpiration?: string;
  addressesV2: AddressV2[];
  isCreditGold? = false;
  primaryAddress? = '';
  MemberSince?: Date;
  GoldSince?: Date;
  creditGoldSince?: Date;
  error?: boolean;
}
